import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { trigger, transition, style, animate } from '@angular/animations';

export type AlertType = 'success' | 'error';

@Component({
  selector: 'app-generic-alert',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './generic-alert.component.html',
  styleUrls: ['./generic-alert.component.css'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-20px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0, transform: 'translateY(-20px)' }))
      ])
    ])
  ]
})
export class GenericAlertComponent implements OnChanges, OnDestroy {
  /** Identificador do alerta, usado para forçar re-disparo mesmo com mesma mensagem */
  @Input() alertId?: number;
  @Input() type: AlertType = 'success';
  @Input() message: string = '';
  @Input() duration: number = 5000;

  show: boolean = false;
  private timeoutId: any = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['alertId'] || changes['message'] || changes['type'] || changes['duration']) {
      // Sempre que um novo alerta chegar (novo id) ou alguma propriedade relevante mudar,
      // reinicia o timer e exibe o alerta, desde que haja mensagem.
      if (this.message) {
        this.restartTimer();
      }
    }
  }

  ngOnDestroy(): void {
    this.clearTimer();
  }

  private restartTimer(): void {
    this.clearTimer();
    this.show = true;

    const effectiveDuration = this.duration ?? 5000;
    this.timeoutId = setTimeout(() => {
      this.show = false;
      this.timeoutId = null;
    }, effectiveDuration);
  }

  private clearTimer(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
} 